import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { RootState } from '../store';
import { createResetAction } from '../../utils';

interface BatchProcessorState {
  selectedDate: string;
}

const initialState: BatchProcessorState = {
  selectedDate: dayjs().format('YYYY-MM-DD')
};

const batchProcessorSlice = createSlice({
  name: 'batchProcessor',
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
    resetBatchProcessor: createResetAction(initialState)
  }
});

export const { setSelectedDate, resetBatchProcessor } =
  batchProcessorSlice.actions;
export default batchProcessorSlice.reducer;

export const getSelectedDate = (state: RootState) =>
  state?.batchProcessor?.selectedDate;
